import { Component, ViewEncapsulation } from '@angular/core';
import { UploadType } from '../merchant-products.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'add-product-dialog',
  templateUrl: './add-product-dialog.component.html',
  styleUrls: [
    './add-product-dialog.component.scss',
    '../../../../../../styles/default-material-theme.scss',
    '../../../../../../styles/m3-defaul-material-theme.scss',
  ],
})
export class AddProductDialogComponent {
  selectedUploadType: UploadType = UploadType.None;
  uploadType = UploadType;

  constructor(private dialogRef: MatDialogRef<AddProductDialogComponent>) {}
}
